"use client";
import { useSelector } from "react-redux";
import Link from "next/link";
import { styled } from "@mui/material/styles";
import Image from "next/image";

const Logo = ({ width = 40, height = 40 }) => {
  const customizer = useSelector((state) => state.customizer);
  const LinkStyled = styled(Link)(() => ({
    height: height || customizer.TopbarHeight,
    width: width,
    overflow: "hidden",
    display: "block",
  }));

  return (
    <LinkStyled href="/">
      {customizer.activeMode === "dark" ? (
        <Image
          src="/images/logos/light-logo.svg"
          alt="logo"
          height={height || customizer.TopbarHeight}
          width={width}
          priority
        />
      ) : (
        <Image
          src="/images/logos/dark-logo.svg"
          alt="logo"
          height={height || customizer.TopbarHeight}
          width={width}
          priority
        />
      )}
    </LinkStyled>
  );
};

export default Logo;
